// import Messages from '@/components/#pages/messages/Messages'
// import MessagesList from '@/components/#pages/messages/MessagesList'

import Conversation from '@/components/#pages/conversation/Conversation'
import Buzon from '@/components/#pages/buzon/BuzonHome'

export default [
    // {
    //     path: '/message',
    //     component: Messages,
    //     children: [
    //         {
    //             path: 'conversation/:id',
    //             component: MessagesList
    //         }
    //     ]
    // },
    {
        path: '/conversation/:conversation_url?',
        component: Conversation
    },
    {
        path: '/buzon',
        component: Buzon
    }
]


// WEBPACK FOOTER //
// ./src/router/buzon.js